import React, { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import "../DeshBoard.css";
import CompanyList from "./CompanyList";
import FinancialOverviewScreen from "./FinancialOverviewScreen";
import CompanyOverview from "../CompanyOverview";
import { Api } from "../../../services/httpService";

const FinancialInformation = (props) => {
  const [displayOverView, setDisplayOverView] = useState(false);
  const [displayCompanyList, setDisplayCompanyList] = useState(true);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const merchantId = localStorage.getItem("_id");
  const [companyName, setCompanyName] = useState("");

  const [valueSalesForecast, setValueSalesForecast] = useState(false);
  const [valueAuditReport, setValueAuditReport] = useState(false);
  const [valueVatReturns, setValueVatReturns] = useState(false);
  const [loading, setLoading] = useState(false);
  const [financialInfo, setFinancialInfo] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [companyData, setCompanyData] = useState({});
  const [sectionStatus, setSectionStatus] = useState(null);



  function handleOverviewScreen() {
    setDisplayOverView(true);
    setDisplayCompanyList(false);
  }

  function handleCompanyList() {
    setDisplayOverView(false);
    setDisplayCompanyList(true);
  }
  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const response = await Api("get", `/company/companyList/${merchantId}`);

      if (response && response.body) {

        setCompanies(response.body);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);

    } 
  };
  useEffect(() => {
    if (merchantId) {
      fetchCompanies();
    }
  }, [merchantId, setValueSalesForecast, setValueAuditReport, setValueVatReturns, financialInfo]);
  return (
    <div className="deshboard-content">
      <div className="dashboard-head pb-4 mb-2">
        <div className="container">
          <div className="company-list-content">
            <div className="row align-items-end">
              <div className="col-7">
                <div className="breadcrumb-section mb-3">
                  {!financialInfo && (
                    <ul className="breadcrumb">
                      <li>Company List</li>
                    </ul>
                  )}

                  {financialInfo && (
                    <ul className="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={() => {
                            setFinancialInfo(false);
                          }}
                        >
                          Company List
                        </a>
                      </li>
                      <li>Finance Overview</li>
                    </ul>
                  )}
                </div>
                <div>
                  {financialInfo ? (
                    <div>
                      <h1 className="company-title mb-2">
                        {companyName || ""}
                      </h1>
                    </div>
                  ) : (
                    <div>
                      <h1 className="company-title mb-2">My Companies</h1>
                      <p className="com-sub-title">
                        Tell us more about your company so we can tailor your
                        credit options
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {financialInfo ? (
        <FinancialOverviewScreen
          setValueAuditReport={setValueAuditReport}
          setValueSalesForecast={setValueSalesForecast}
          setValueVatReturns={setValueVatReturns}
          valueVatReturns={valueVatReturns}
          valueAuditReport={valueAuditReport}
          valueSalesForecast={valueSalesForecast}
          setUploadedFiles={setUploadedFiles}
          companyId={companyId}
          companyData={companyData}
          triggerProgressRefresh={props?.triggerProgressRefresh}
         
        />
      ) : (
        <CompanyList
          setCompanyName={setCompanyName}
          loading={loading}
          setLoading={setLoading}
          companies={companies}
          fetchCompanies={fetchCompanies}
          setValueAuditReport={setValueAuditReport}
          setValueSalesForecast={setValueSalesForecast}
          setValueVatReturns={setValueVatReturns}
          showOverView={(val) => setFinancialInfo(val)}
          setCompanyId={(id) => {
            setCompanyId(id);
          }}
          setCompanyData={(data) => setCompanyData(data)}
          triggerProgressRefresh={props?.triggerProgressRefresh}
          setSectionStatus={setSectionStatus}
        />
      )}
    </div>
  );
};

export default FinancialInformation;
